const UploadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.95833 7.64167C7.125 7.80833 7.38333 7.80833 7.55 7.64167L9.16667 6.025V15.9333C9.16667 16.1667 9.35 16.35 9.58333 16.35H10.4167C10.65 16.35 10.8333 16.1667 10.8333 15.9333V6.025L12.45 7.64167C12.6167 7.80833 12.875 7.80833 13.0417 7.64167L13.6333 7.05C13.8 6.88333 13.8 6.625 13.6333 6.45833L10.3 3.125C10.1333 2.95833 9.875 2.95833 9.70833 3.125L6.375 6.45833C6.20833 6.625 6.20833 6.88333 6.375 7.05L6.96667 7.64167H6.95833Z"
      fill="white"
    />
  </svg>
);

export default UploadIcon;
